import { EpisodeWithUser } from "./episodes-types";
import { ImageBase } from "./images-types";
import { SubmissionState } from "./submission-types";

export type MaskBase = {
  id: string;
  url?: string;
  state: MaskState;
  submissionState: SubmissionState;
  createdAt: string;
  updatedAt: string;
  modelName: string | null;
  generationTime: number | null;
  generationId: string | null;
  generationError: string | null;
};

export type MaskWithImage = MaskBase & {
  image: ImageBase;
};

export type MaskDetails = MaskBase & {
  episode: EpisodeWithUser;
  episodeTitle: string;
  image: ImageBase;
  rejectionReasons: string[];
};

export enum MaskState {
  "waiting" = "waiting",
  "generationFailed" = "generationFailed",
  "retryScheduled" = "retryScheduled",
  "new" = "new",
  "accepted" = "accepted",
  "rejected" = "rejected",
}
